import { Link } from 'react-router-dom'
import { Button } from '../components/common'

function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="text-9xl font-bold text-gray-200">404</div>
        <h1 className="text-3xl font-bold text-gray-800 mt-4">Halaman Tidak Ditemukan</h1>
        <p className="text-gray-500 mt-2 mb-6">
          Maaf, halaman yang Anda cari tidak ada atau telah dipindahkan.
        </p>
        <div className="flex gap-4 justify-center">
          <Link to="/">
            <Button>🏠 Kembali ke Dashboard</Button>
          </Link>
          <Button variant="secondary" onClick={() => window.history.back()}>
            ← Halaman Sebelumnya
          </Button>
        </div>
      </div>
    </div>
  )
}

export default NotFoundPage
